export default __webpack_public_path__ + "static/media/chronos-senala.2aceaf4a.png";